// extracted by mini-css-extract-plugin
export default {"container":"styles_container__2wHMn","title":"styles_title__KftQl"};